import React from 'react'
const EmptyCart = () => {
  return (
    <h1>Your Cart is empty</h1>
  )
}

export default EmptyCart
